<immo-sidebar>
    <!-- HEADER -->
    <div ngProjectAs="immo-sidebar-header" class="flex gap-2 items-center justify-center p-5">
        <mat-icon svgIcon="ambos-immo" class="size-8! shrink-0" />
        <h5 [class.opacity-0]="!isExpanded()" [class.hidden]="!isExpanded()"
            class="truncate text-lg! uppercase font-medium transition-all duration-300">
            Ambos Immo
        </h5>
    </div> <!-- /header -->
    <immo-navigation [navigation]="navigation()" [isExpanded]="isExpanded()" />

    <!-- FOOTER: on desktop the sidebar IS the chrome — assistant and profile/logout live
         here (the header only exists below layout-bp) -->
    <div ngProjectAs="immo-sidebar-footer" class="flex shrink-0 flex-col gap-2">
        <button type="button"
            class="flex items-center gap-2 rounded-sm p-2 bg-sidebar hover:brightness-95 hover:dark:brightness-125 transition-all duration-150"
            [class.justify-center]="!isExpanded()" matRipple [matTooltipShowDelay]="300"
            [matTooltipPosition]="'right'" [matTooltip]="'Assistant.Title' | translate"
            (click)="openAssistant()">
            <mat-icon class="size-5! shrink-0" [svgIcon]="'chat-circle-dots'" />
            @if (isExpanded()) {
            <span class="truncate text-sm">{{ 'Assistant.Title' | translate }}</span>
            }
        </button>

        <!-- The WHOLE row triggers the menu (same visual language as the assistant button
             above); the panel opens UPWARDS + left-aligned so it never leaves the viewport
             at the sidebar's foot -->
        <immo-profile-menu class="block"
            [triggerClass]="'flex w-full items-center gap-2 rounded-sm p-2 bg-sidebar hover:brightness-95 hover:dark:brightness-125 transition-all duration-150 ' + (isExpanded() ? '' : 'justify-center')"
            [positions]="profileMenuPositions">
            @if (isExpanded()) {
            <span immoProfileMenuTrigger class="min-w-0 truncate text-sm">{{ user()?.fullName }}</span>
            }
            <ng-container ngProjectAs="immo-profile-menu-header">
                <span class="font-medium">{{ user()?.fullName }}</span>
                <a class="underline font-light" [href]="`mailto:${user()?.email}`">{{ user()?.email }}</a>
            </ng-container>
        </immo-profile-menu>
    </div>
</immo-sidebar>
